import * as React from 'react';
import cn from 'clsx';
import { ArticleHeading1, LinkButton } from '@cian/ui-kit';

import { BigHeading } from '../BigHeading';
import { withDeviceType, IWithDeviceTypeProps } from '../../utils/withDeviceType';
import { IDealFeatureCard } from '../../types/promoInfo';
import { FeatureCard } from '../FeatureCard';

import * as styles from './styles.css';

interface IDealFlexibilitySectionProps extends IWithDeviceTypeProps {
  dealFormUrl: string;
  features: IDealFeatureCard[];
  onAboutFeatureButtonClick: (card: IDealFeatureCard) => void;
  onNavigateToDealFormClick: () => void;
}

/**
 * Секция "Гибкий подход к сделкам".
 */
const DealFlexibilitySection: React.FC<React.PropsWithChildren<IDealFlexibilitySectionProps>> = ({
  features,
  onAboutFeatureButtonClick,
  isPhone,
  deviceType,
  dealFormUrl,
  onNavigateToDealFormClick,
}) => {
  const Heading = isPhone ? ArticleHeading1 : BigHeading;

  return (
    <div className={cn(styles['container'], styles[deviceType])}>
      <Heading as="h2" color="white_100">
        Гибкий подход к сделкам
      </Heading>
      <div className={cn(styles['features'], styles[deviceType])}>
        {features.map((feature, i) => (
          <FeatureCard
            key={i}
            {...feature}
            gradient={i % 2 === 0 ? 'blue-to-pink' : 'yellow-to-blue'}
            onButtonClick={() => onAboutFeatureButtonClick(feature)}
            buttonText="Процесс по шагам"
            theme="light"
          />
        ))}
      </div>
      <LinkButton onClick={onNavigateToDealFormClick} href={dealFormUrl} size="L" fullWidth>
        Провести сделку
      </LinkButton>
    </div>
  );
};

const DealFlexibilitySectionWithDeviceType = withDeviceType(DealFlexibilitySection);
export { DealFlexibilitySectionWithDeviceType as DealFlexibilitySection };
